import { render, staticRenderFns } from "./PreguntasFrecuentesView.vue?vue&type=template&id=a5e43c08&scoped=true&"
import script from "./PreguntasFrecuentesView.vue?vue&type=script&lang=ts&"
export * from "./PreguntasFrecuentesView.vue?vue&type=script&lang=ts&"
import style0 from "./PreguntasFrecuentesView.vue?vue&type=style&index=0&id=a5e43c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e43c08",
  null
  
)

export default component.exports